import { FormWithRedux } from '../../FormWithRedux';

export class EDChestPainNotesForm extends FormWithRedux {

    constructor(parent) {
        super('notesForm', parent);
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);
        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory() {
        return false;
    }

    getValueType() {
        return 'string';
    }

    submissionValidation() {
        return [];
    }

    detailString() {
        return 'summary';
    }

}


// WEBPACK FOOTER //
// ./src/forms/edChestPain01/Forms/EDChestPain-NotesForm.js